import CodeMirror from 'codemirror'
import "codemirror/addon/mode/simple"

CodeMirror.defineSimpleMode("leafmode", {
    entities: [
        {regex: /([^,\(]+)(\([^,]*)/, token: ["entity", "comment"]},
        {regex: /([^,\(]+)/, token: "entity"},
    ],
    start: [
        {regex: /\w+:\/\/.*/, token: "url"},
        {regex: /[^=:]*=/, token: "prefix", next: "text"},
        {regex: /[^:\d]{1,25}:/, token: "predicate", next: "entities"},
        {regex: /:/, token: "predicate", next: "entities"},


        {regex: /#[\w_]*/, token: 'hashtag', next: 'start'},


        // {regex: /\[.*?\]/, token: 'hashtag', next: 'start'},
        // {regex: /\[[^\]]*$/, token: 'hashtag', next: 'start'},

        // {regex: /#\w*/, token: 'hashtag', next: 'start'},

        {regex: /[^#]*/, token: "text"},
        // {regex: /.*/, token: "text"},
    ],
    text: [
        {regex: /\w+:\/\/.*/, token: "url"},
        // {regex: /\[.+?\]/, token: 'hashtag'},
    ],
    comment: [
        {regex: /.*?\*\//, token: "comment", next: "start"},
        {regex: /.*/, token: "comment"}
    ]
});


CodeMirror.defineSimpleMode("rootmode", {
    entity: [
        {regex: /([^,\(]+)/, token: "entity"},
        // {regex: /<ref-.*?>/, token: "entity" },
    ],
    edge: [
        {regex: /([^,\(]+)/, token: "edge"},
        // {regex: /<ref-.*?>/, token: "entity" },
    ],
    operation: [
        {regex: /([^,\(]+)/, token: "text"},
        // {regex: /<ref-.*?>/, token: "entity" },
    ],
    post: [
        {regex: /\-+\>/, token: "arrow", next: "entity"},
        {regex: /\&/, token: "arrow", next: "entity"},
        {regex: /\/\//, token: "arrow", next: "operation"},
        // {regex: /\./, token: "arrow", next: "edge"}
    ],
    start: [
        // {regex: /.*?/, token: "entity", next: "post" },
        // {regex: /(.*?)(\-+\>)/, token: ["text", "arrow"], next: "entity" },
        // {regex: /.*/, token: "entity"}

        {regex: /.*?/, token: "entity", next: "post"}
    ]
});



CodeMirror.defineSimpleMode("edgemode", {
    // entity: [
    //     {regex: /([^,\(]+)/, token: "entity"},
    // ],
    start: [
        // {regex: /(.*?)(\-+\>)/, token: ["text", "arrow"], next: "entity" },
        // {regex: /Recently Added|Statistics/, token: "builtin"},
        // {regex: /.*/, token: "entity"}
        
        {regex: /([^,\(]+)(\([^,]*)/, token: ["entity", "comment"]},
        {regex: /([^,\(]+)/, token: "entity"},
    ],
    comment: [
        {regex: /.*?\*\//, token: "comment", next: "start"},
        {regex: /.*/, token: "comment"}
    ]
});




// WEBPACK FOOTER //
// ./src/editor/mode.js